import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import axios from 'axios';
import InventoryGraph from '../graphs/InventoryGraph';
import SalesGraph from '../graphs/SalesGraph';
import OrdersGraph from '../graphs/OrdersGraph';
import { ArrowLeft } from 'lucide-react';

function TodaysSalesProductDetailPage() {
  const { id } = useParams();
  const [productData, setProductData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/product/${id}`)
      .then(response => setProductData(response.data))
      .catch(error => console.error('Error fetching product data:', error));
  }, [id]);

  if (!productData) return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
      <CircularProgress size={32} thickness={3} />
    </Box>
  );

  return (
    <Box className="fade-in">
      <Button
        onClick={() => navigate('/todays-graphs')}
        startIcon={<ArrowLeft size={16} />}
        sx={{ mb: 2, color: 'text.secondary', fontWeight: 500 }}
      >
        Back to Today's Graphs
      </Button>

      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', mb: 0.5 }}>
        {productData.title}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
        Product ID: {id}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 3 }}>
          <InventoryGraph productId={id} />
        </Box>
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 3 }}>
          <SalesGraph inventoryLevels={productData.inventoryLevels} productId={id} />
        </Box>
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 3 }}>
          <OrdersGraph inventoryLevels={productData.inventoryLevels} />
        </Box>
      </Box>
    </Box>
  );
}

export default TodaysSalesProductDetailPage;
